import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { OperationType } from './../../../widgets/filters/miscellaneous/operation-type.enum';
import { QueryFilterParameter } from './../../../widgets/filters/models/query-filter-parameter.model';
import {ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import {DxChartComponent, DxDataGridComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import {  ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { ForecastChartCaption } from 'src/app/models/forecast/fc-overview-models';
import { NotificationService } from 'src/app/services/notification.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { EsoService } from '../../eso/eso.service';
import { HelpService } from '../../help/help.service';
import { TaskDataFilter } from '../../stock/stock.service';
import { TaskService } from '../../task/task.service';
import {  CapacityOverviewTableData, CapacityService } from '../capacity.service';
import { UtilsService } from 'src/app/services/utils.service';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';


import { FileExportService } from 'src/app/common/file-export-service';
import { DevTooltipCustComponent } from 'src/app/widgets';
import { SelectStatementResult } from 'src/app/models/select-statement-result.model';
import { GeneralSettings, SettingsService } from '../../settings/settings.service';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { DxChartBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-chart-bookmark-elements.operator';
import { firstValueFrom } from 'rxjs';
import { Data } from '@angular/router';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { TableDataOperator } from 'src/app/operators/table-data.operator';

@Component({
    selector: 'app-capacity-overview',
    templateUrl: './capacity-overview.component.html',
    styleUrls: ['./capacity-overview.component.scss'],
    standalone: false
})
export class CapacityOverviewComponent implements OnInit {
	private readonly _componentTitle = "Capacity Overview";

	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.DEV_GetCapacityOverviewChartData,
				selectionSetId: SelectionSetId.CapacityOverviewFilters,
			}
		)
	);

	public chartTableDataOperator: TableDataOperator = new TableDataOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.DEV_GetCapacityOverviewChartData,
				selectionSetId: SelectionSetId.CapacityOverviewChartData,
			}
		)
	);

	@ViewChild('bookmarksGroup', { static: true })
	public bookmarksGroup: BookmarkNewComponent;

	public bookmarkElementsOperators: BookmarkElementsOperator[];

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator(
				{
					id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
					filtersOperator: () => this.pageFiltersOperator
				}
			),
			new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.dxMainChart
			),
		];

		return routeData;
	}

	public async loadPageData(): Promise<void> {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (response) => {


					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.getCapacityList();
						this.getPeriodList();
						this.getData();
						this.loadLengendToShare();
						this.getGeneralTableData();
						this.getCapacityMatrixData();
					}
				}
			}
		);
	}

	@ViewChild("mainChart", { static: false }) dxMainChart: DxChartComponent;
	@ViewChild("capacityChart", { static: false }) dxCapacityChart: DxChartComponent;
	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

	tableDataSource: DataSource = new DataSource(
		{
			load: (loadOptions): Promise<any> => {
				let observable$ = this.capacityService.getOverviewTableData(
					this.pageFiltersOperator.overviewFiltersOutput.action,
					this.pageFiltersOperator.overviewFiltersOutput.filters,
					this.selectedCapacityColumn,
					this.selectedPeriod
				).toPromise();

				return observable$.then(
					(response) => {
						console.log("tableData[load] - response:", response);

						response.forEach(
							x => {
								x.difference = x.supplyTotalProductionTime - x.forecastTotalProductionTime;
							}
						);

						return response;
					},
					(error) => {
						console.log(error);

						this.notificationService.error(error.message);
					}
				);
			}
		}
	);
	selectedCapacityColumn: string;
	capacityList: ForecastChartCaption[] = [];

	supplyTotalCaption: string;
	fcTotalCaption: string;
	visualRange: any = {};

	periodList: string[] = [];
	selectedPeriod: string = ' ';
	period = "period";
	capacityGeneralTableFullInfo: CapacityOverviewTableData[] = [];
	capacityGeneralTableCaptions: any[] = [];

	toggleTableValue = true;

	matrixColumns: { columnName: string; caption: string; dataType: string }[] = [];
	matrixData: {
		IsDirty: boolean;
		ProductId: string;
		[key: string]: string | number | boolean;
	}[] = [];
	matrixDataSource: any = {};

	matrixFinalizeData: any = {};
	matrixProducingData: any = {};
	matrixPickForProdData: any = {};

	matrixCell80Color = '';
	matrixCell90Color = '';
	matrixCell100Color = '';
	matrixGrandTotalValues = [];

	clientCodes = [{
		name: '',
		items: []
	}];

	generalSettings: GeneralSettings;

	constructor(private capacityService: CapacityService,
		private notificationService: NotificationService,
		private helpService: HelpService,
		private titleService: Title, private shareDataService: ShareDataService,
		private _activatedRoute: ActivatedRoute,
		private taskService: TaskService,
		private esoService: EsoService, private fileExportService: FileExportService,
		private settingsService: SettingsService,
		private tableParamService: TableParameterService) {
		console.log('constructor');
	}

	taskFilterData: TaskDataFilter[];
	IsTaskLoad = false;
	filterMappingService = new FilterMappingService();
	async ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		this.settingsService.getGeneralSettings().subscribe(res => {
			this.generalSettings = res;
		});

		this._activatedRoute.paramMap.subscribe(
			(params) => {
				const value = this._activatedRoute.snapshot.queryParamMap.get("taskid");
				if (value) {

					this.taskService.SelectTaskFilterValues(value).subscribe(
						{
							next: async (data) => {
								this.taskFilterData = data;
								this.taskFilterData.forEach(element => {
									let filterItem: QueryFilterParameter = new QueryFilterParameter(
										element.fieldName,
										element.settingValue,
										OperationType.Contains
									);

									this.pageFiltersOperator.overviewFiltersOutput.filters.push(filterItem);
								});
								this.IsTaskLoad = true;

								this.getData();
								this.getCapacityList();
								this.getPeriodList();
								this.getGeneralTableData();
								this.getCapacityMatrixData();
							}
						}
					);
				}
			});

		this.pageFiltersOperator.onFiltersApplied.subscribe(
			(selection) => {
				this.shareDataService.CleanData();
				this.shareDataService.filterOptionOverview = this.pageFiltersOperator.overviewFiltersOutput;

				this.shareDataService.capacityOverviewSelectedColumn = this.selectedCapacityColumn;

				this.shareDataService.periodType = this.selectedPeriod;
				this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.shareDataService.filterOptionOverview.filters);
				this.pageFiltersOperator.load();

				this.getCapacityList();
				this.getPeriodList();
				this.getData();
				this.loadLengendToShare();
				this.getGeneralTableData();
				this.getCapacityMatrixData();

				this.tableDataSource.reload();
			}
		);

		this.GetSettingsData();
		this.WebSettingsPivot();

		await this.initializeBookmarks();

		this.loadPageData();
	}

	public onToggleTableClick(event: boolean) {
		this.toggleTableValue = event;
		setTimeout(() => {
			this.LoadChartSeries();
		}, 1000);

	}

	getCapacityMatrixData() {
		if (this.selectedPeriod && this.selectedCapacityColumn) {
			this.capacityService.getCapacityMatrix(this.pageFiltersOperator.overviewFiltersOutput.filters, this.selectedPeriod,
				this.selectedCapacityColumn)
				.subscribe(res => {
					this.matrixDataSource = {};
					this.matrixDataSource.fields = [];
					this.matrixDataSource.store = {};

					for (let i = 0; i < res.columns.length; i++) {
						let area = '';
						let summaryType = 'count';
						if (res.columns[i].columnName === 'CapacityClientCode' || res.columns[i].columnName === 'CapacityGroup1'
							|| res.columns[i].columnName === 'CapacityGroup2' || res.columns[i].columnName === this.selectedCapacityColumn) {
							area = 'row';
							this.matrixDataSource.fields.push({
								caption: res.columns[i].caption,
								width: 60,
								dataField: res.columns[i].columnName,
								area: area,
								summaryType: summaryType
							});
						} else if (res.columns[i].columnName === 'YearMonth' || res.columns[i].columnName === 'YearWeek') {
							area = 'column';
							this.matrixDataSource.fields.push({
								caption: res.columns[i].caption,
								width: 60,
								dataField: res.columns[i].columnName,
								area: area,
								summaryType: summaryType
							});
						} else {
							area = 'data';
							summaryType = 'sum';

							if (!this.matrixDataSource.fields.find(x => x.caption === 'Percent')) {
								this.matrixDataSource.fields.push({
									caption: 'Percent',
									width: 60,
									dataField: 'Percent',
									area: area,
									summaryType: summaryType
								});
							}
						}
					}

					for (let i = 0; i < res.data.length; i++) {
						if (res.data[i].SupplyTotalProductionTime > 1) {
							res.data[i].Percent = Math.round(res.data[i].ForecastTotalProductionTime * 100 / res.data[i].SupplyTotalProductionTime);
						} else {
							res.data[i].Percent = undefined;
						}
					}

					this.matrixDataSource.store = res.data;
					this.matrixFinalizeData = res.data.filter(x => x[this.selectedCapacityColumn] === 'Finalize');
					this.matrixProducingData = res.data.filter(x => x[this.selectedCapacityColumn] === 'Producing');
					this.matrixPickForProdData = res.data.filter(x => x[this.selectedCapacityColumn] === 'PickingForProduction');
				});
		}
	}

	onCellPrepared(e) {
		if (e.area == "data" && e.cell.text == "0") {
			e.cellElement.textContent = " ";
		}

		if (e.cell.rowType === 'GT') {
			let period = e.cell.columnPath ? e.cell.columnPath[0] : undefined;

			if (period !== undefined) {
				let finValue = this.matrixDataSource.store.filter(x => (x.YearMonth === period || x.YearWeek === period));

				let forecastSum = 0;
				let supplySum = 0;
				finValue.forEach(element => {
					if (element.ForecastTotalProductionTime != undefined) {
						forecastSum += element.ForecastTotalProductionTime;

						supplySum += element.SupplyTotalProductionTime;
					}
				});

				if (forecastSum > 0 && supplySum > 0) {
					e.cell.value = Math.round(forecastSum * 100 / supplySum);
					e.cellElement.textContent = (Math.round(forecastSum * 100 / supplySum)).toString();
				}
			}
		}

		if (e.cell.columnType == 'GT') {
			let finValue = this.matrixDataSource.store.filter(x => (Object.values(x)[0] === e.cell.rowPath[0]));

			let forecastSum = 0;
			let supplySum = 0;
			finValue.forEach(element => {
				if (element.ForecastTotalProductionTime != undefined) {
					forecastSum += element.ForecastTotalProductionTime;

					supplySum += element.SupplyTotalProductionTime;
				}
			});

			if (forecastSum > 0 && supplySum > 0) {
				e.cell.value = Math.round(forecastSum * 100 / supplySum);
				e.cellElement.textContent = (Math.round(forecastSum * 100 / supplySum)).toString();
			}
		}

		if (e.area === 'data' && e.cell.rowType !== 'GT' && e.cell.columnType !== 'GT') {
			const normalValue = this.generalSettings.settings.find(x => x.name == 'NormalUpToNumber');
			const warningValue = this.generalSettings.settings.find(x => x.name == 'WarningUpToNumber');
			const criticalValue = this.generalSettings.settings.find(x => x.name == 'CriticalUpToNumber');

			if (!normalValue.value || !warningValue.value || !criticalValue.value) {
				this.notificationService.warning('Values for coloring are missing. Please, configure them in the settings', 10000);
			}

			if (e.cell.value <= +normalValue.value) {
				let opacity = e.cell.value / +normalValue.value;
				let color = this.generalSettings.settings.find(x => x.name === 'NormalColor').value;

				if (e.cell.value != 0)
					e.cellElement.style.backgroundColor = "rgba(" + color + ", " + (1.2 - opacity) + ")";

			} else if (e.cell.value > +normalValue.value && e.cell.value <= +warningValue.value) {
				let opacity = e.cell.value / +warningValue.value;
				let color = this.generalSettings.settings.find(x => x.name === 'WarningColor').value;
				e.cellElement.style.backgroundColor = "rgba(" + color + ", " + opacity + ")";
			} else if (e.cell.value > +warningValue.value) {
				let opacity = e.cell.value / +criticalValue.value;
				let color = this.generalSettings.settings.find(x => x.name === 'CriticalColor').value;
				e.cellElement.style.backgroundColor = "rgba(" + color + ", " + opacity + ")";
			}
		}
	}

	getPeriodList() {
		this.esoService.getSupplyForecastPeriodList().subscribe(res => {
			this.periodList = res;
			this.selectedPeriod = res[1];
			console.log(this.selectedPeriod);
		});
	}

	getGeneralTableData() {
		this.capacityService.getOverviewGeneralTableData(this.pageFiltersOperator.overviewFiltersOutput.filters).subscribe(res => {
			this.capacityGeneralTableFullInfo = res.table1;
			this.capacityGeneralTableCaptions = res.table;
			setTimeout(() => {
				this.LoadChartSeries();
			}, 1000);
		});
	}

	onPeriodChanged(e) {
		this.getCapacityMatrixData();
		this.tableDataSource.reload();
	}

	capacityGroupChanged(e) {
		this.selectedCapacityColumn = e.selectedItem.fieldName;
		this.tableDataSource.reload();
		this.getCapacityMatrixData();
	}

	private getCapacityList() {
		this.capacityService.getCapacityListNew().subscribe(res => {
			this.capacityList = res;
			console.log(res);
			if (res != null && res != undefined && res.length > 0 && !this.selectedCapacityColumn) {
				this.selectedCapacityColumn = res[0].fieldName;
			}
			this.tableDataSource.reload();
		});
	}

	private async getData() {
		(await this.chartTableDataOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: (selectStatementResult: SelectStatementResult) => {
					this.supplyTotalCaption = selectStatementResult.columns.find((column) => column.columnName == 'SupplyTotalProductionTime').caption;
					this.fcTotalCaption = selectStatementResult.columns.find((column) => column.columnName == 'ForecastTotalProductionTime').caption;
				}
			}
		);
	}

	public onTableDataSortingChange(event: any) {
		console.log("onTableDataSortingChange - event:", event);
	}

	rowButtonClicked(e, data) {
		e.event.stopPropagation();
		this.IsTaskLoad = true;
		window.open('capacity/deep-dive?productId=' + UtilsService.getURLHelper(data.data.productId), '_blank');
		this.IsTaskLoad = false;
	}


	IsExportEnable = false;
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportCapacityOverview").subscribe(resultFilename => {
			this.IsExportEnable = resultFilename.value.toLowerCase() == "yes" ;
		}, err => {
			console.log(err);
		});
		this.fileExportService.WebSettings("EnableExportcapacityoverviewList").subscribe(resultFilename => {
			this.IsExportListEnable = resultFilename.value.toLowerCase() == "yes" ;
		}, err => {
			console.log(err);
		});
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotCapacityOverview").subscribe(result => {
			console.log(result);
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipCapacityOverview != null
				&& result[0].defaultSelectionTooltipCapacityOverview.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipCapacityOverview != null
				&& result[0].enableDisableTooltipCapacityOverview.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "", "", "");
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	//hide and show series on click
	onLegendClickMainChart(e: any) {
		const series = e.target;
		let ShowHide = false;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();

		}
		this.loadLengendToShare();
	}

	loadLengendToShare() {
		let seriesValues = { DevelopmentChart: [], Grouped: [], ScopeList: [] };
		if (this.dxMainChart?.instance?.getAllSeries() != null) {
			this.dxMainChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.DevelopmentChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		if (this.dxCapacityChart?.instance?.getAllSeries() != null) {
			this.dxCapacityChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.Grouped.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	ChartSettings: any;
	LoadChartSeries() {
		if (Array.isArray(this.dxMainChart.series) && this.dxMainChart?.series != null
			&& this.dxMainChart.series.length > 0) {
			for (let index = 0; index < this.dxMainChart.series.length; index++) {
				this.dxMainChart.series[index].visible = true;
			}
		}
		if (Array.isArray(this.dxCapacityChart.series) && this.dxCapacityChart?.series != null
			&& this.dxCapacityChart.series.length > 0) {
			for (let index = 0; index < this.dxCapacityChart.series.length; index++) {
				this.dxCapacityChart.series[index].visible = true;
			}
		}
		if (this.ChartSettings != null) {
			if (this.ChartSettings.DevelopmentChart != null && this.ChartSettings.DevelopmentChart.length > 0) {
				if (Array.isArray(this.dxMainChart.series) &&this.dxMainChart?.series != null
					&& this.dxMainChart.series.length > 0) {
					for (let index = 0; index < this.dxMainChart.series.length; index++) {
						this.ChartSettings.DevelopmentChart.forEach(itemchrt => {
							if (this.dxMainChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxMainChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxMainChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxMainChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings != null) {
				if (this.ChartSettings.Grouped != null && this.ChartSettings.Grouped.length > 0) {
					if (Array.isArray(this.dxCapacityChart.series) && this.dxCapacityChart?.series != null
						&& this.dxCapacityChart.series.length > 0) {
						for (let index = 0; index < this.dxCapacityChart.series.length; index++) {
							this.ChartSettings.Grouped.forEach(itemchrt => {
								if (this.dxCapacityChart.series[index].valueField != null
									&& itemchrt.isVisible != null && (this.dxCapacityChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
										|| this.dxCapacityChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
								) {
									this.dxCapacityChart.series[index].visible = itemchrt.isVisible;
								}
							});
						}
					}
				}

				if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
					if (this.dataGrid?.instance != null) {
						this.ChartSettings.ScopeList.forEach(element => {
							this.dataGrid.instance.beginUpdate();
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
							if (element.filterType != null && element.filterType != undefined) {
								this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
							}
							this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
							this.dataGrid.instance.endUpdate();
						});
					}
				}



			}
		}
		if (this.dxMainChart) { this.dxMainChart.instance.refresh(); }
		if (this.dxCapacityChart) { this.dxCapacityChart.instance.refresh(); }
	}

	//scope table
	fitScopeTableToPage = false;
	changeFitToScopePageStatus() {
		this.fitScopeTableToPage = !this.fitScopeTableToPage;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	anyScopeTableActiveFilters = false;
	changeScopeTableActiveFiltersStatus() {
		if (this.anyScopeTableActiveFilters) {
			this.anyScopeTableActiveFilters = !this.anyScopeTableActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}

	onToolbarScopeTablePreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift({
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'bookmarkButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}

	ScopeList = [];
	saveState = (statenew) => {
		this.ScopeList = [];
		if (statenew?.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const curFilter = evt.component.getCombinedFilter();
		if (curFilter) {
			this.anyScopeTableActiveFilters = true;
		} else {
			this.anyScopeTableActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-capacity-overview', JSON.stringify(this.dataGrid.instance.state()));
	}

	ExportToExcelFilters: ExportFilter[] = [];
	// Method to receive value from child
	receiveExportToExcelFilters(value: ExportFilter[]) {
		this.ExportToExcelFilters = value;
	  }
}
